import { Object3D } from 'three';
import { $ } from '@/Engine/state';
import { Intersection } from 'three/src/core/Raycaster';
import { IV3D } from '@/Interfaces/v3d';
declare let v3d: IV3D;
const _raycaster = new v3d.Raycaster();

export const getIntersection = (objects: Array<Object3D>):Array<Intersection> => {
    _raycaster.setFromCamera($.pointer, $.app.camera);
    return _raycaster.intersectObjects(objects as Array<Object3D>, true);
};
export const getShelfIntersections = () => {
    const raycastBoxes: Array<Object3D> = [];
    $.wardrobe.shelves
        .filter((item)=>!$.room.invisibleWalls.includes(item.side))
        .forEach((shelf)=>{
        raycastBoxes.push(shelf.raycastBox.model);
    });
    return getIntersection(raycastBoxes);
};

export const getBoxIntersections = () => {
    const raycastBoxes: Array<Object3D> = [];
    $.wardrobe.rackModules
        .filter((item)=>!$.room.invisibleWalls.includes(item.side))
        .forEach((module)=>{
            raycastBoxes.push(module.raycastBox.model);
    });
    raycastBoxes.push(...$.doors
        .filter((item)=>!$.room.invisibleWalls.includes(item.side))
        .map((item)=>item.model));
    raycastBoxes.push(...$.windows
        .filter((item)=>!$.room.invisibleWalls.includes(item.side))
        .map((item)=>item.model));
    raycastBoxes.push(...$.boxes.map((item)=>item._raycastMesh));
    return getIntersection(raycastBoxes);
};

export const getModulesIntersections = () => {
    const raycastBoxes: Array<Object3D> = [];
    $.wardrobe.rackModules
        .filter((item)=>!$.room.invisibleWalls.includes(item.side))
        .forEach((module)=>{
        raycastBoxes.push(module.raycastBox.model);
    });
    return getIntersection(raycastBoxes);
};


export const getSizingBoxesIntersection = () => {
    return getIntersection($.room.sizingBoxes);
};
